import { useSdk } from '~/sdk';

export const useFooter = () => {
  const nuxtApp = useNuxtApp();
  const {locale} = useI18n();

  const footer = useAsyncData(`footer-${locale.value}`, async () =>
      await useSdk().cms.getContent({
        globalSet: {
          handle: 'footer',
          fragment: `
          ... on footer_GlobalSet {
            copyright
            slogan
            socials {
              ... on social_Entry {
                alias
                icon {
                  alt
                  url
                }
                theurl
              }
            }
          }
        `,
        },
      }),
  );

  const menu = useLazyAsyncData(`menu-${locale.value}`, async () => {
    return await useSdk().cms.getContent({
      entries: {
        section: 'menuFooter',
        fragment: `
              title,
              ... on menuFooter_default_Entry {
                id
                title
                slug
                children {
                  id
                  title
                  slug
                  ... on menuFooter_default_Entry {
                    callToAction: featureCallToAction {
                      title
                      target
                      url
                      element {
                        id
                        slug
                        siteId
                      }
                    }
                  }
                }
              }
            `,
      },
    });
  });

  const categories = useLazyAsyncData(`menu-footer-categories-${locale.value}`, async () => {
    return await useSdk().cms.getContent({
      entries: {
        section: 'menuFooterCategories',
        fragment: `
              title
              ... on menuFooter_default_Entry {
                title
                slug
                callToAction: featureCallToAction {
                  url
                }
                children {
                  title
                  slug
                  ... on menuFooter_default_Entry {
                    callToAction: featureCallToAction {
                      url
                    }
                  }
                  children {
                    title
                    slug
                    ... on menuFooter_default_Entry {
                      callToAction: featureCallToAction {
                        url
                      }
                    }
                  }
                }
              }
            `,
      },
    });
  });

  watch(nuxtApp.$i18n.locale, () => {
    footer.refresh();
    menu.refresh();
    categories.refresh();
  });

  return {
    socials: computed(() => footer.data.value?.socials ?? []),
    menu: computed(() => menu.data.value ?? []),
    categories: computed(() => categories.data.value ?? []),
    copyright: computed(() => footer.data.value?.copyright ?? ''),
    slogan: computed(() => footer.data.value?.slogan ?? '')
  };
};
